import { cn } from '@/utils';
import { CaretDownOutlined } from '@ant-design/icons';
import { memo } from 'react';

import { Dropdown as DropdownAntd, DropDownProps, MenuProps } from 'antd';

import './style.scss';

import Button from '../button';
export interface DropdownProps extends DropDownProps {
	label?: string;
	className?: string;
	menuProps?: MenuProps;
	buttonClassName?: string;
}

const Dropdown = ({
	label,
	menuProps,
	buttonClassName,
	...props
}: DropdownProps) => {
	return (
		<DropdownAntd
			menu={{
				subMenuCloseDelay: 0,
				subMenuOpenDelay: 0,
				...menuProps,
			}}
			trigger={['click']}
			className="[&.ant-dropdown-open>button.ant-btn]:!border-blue2 group"
			overlayClassName="my-dropdown"
			align={{ offset: [0, 5] }}
			{...props}
		>
			<div>
				<Button
					className={cn('px-3 text-font2 gap-x-1  w-full', buttonClassName)}
					onClick={(e) => e.preventDefault()}
					icon={
						<CaretDownOutlined className="text-base text-gray12 group-hover:text-blue2" />
					}
					iconPosition="end"
				>
					{label}
				</Button>
			</div>
		</DropdownAntd>
	);
};

export default memo(Dropdown);
